import { hotTopics } from "@/mocks/qxian";

function Trend({ trend }: { trend: string }) {
  if (trend === "new")
    return <span className="rounded-full bg-accent-500 text-background-50 px-2 py-0.5 text-[11px] font-bold">NEW</span>;
  if (trend === "up")
    return (
      <span className="inline-flex items-center gap-1 text-xs text-primary-600">
        <i className="ri-arrow-up-line"></i> 上升
      </span>
    );
  if (trend === "down")
    return (
      <span className="inline-flex items-center gap-1 text-xs text-secondary-600">
        <i className="ri-arrow-down-line"></i> 回落
      </span>
    );
  return (
    <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
      <i className="ri-subtract-line"></i> 持平
    </span>
  );
}

export default function HotRanking() {
  return (
    <section id="rank" className="w-full bg-accent-50/40 scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_320px]">
          <div>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
              <div>
                <span className="inline-flex items-center gap-2 text-xs font-semibold text-accent-700">
                  <i className="ri-medal-line"></i>
                  每小时重排
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">热点话题榜</h2>
                <p className="mt-2 text-sm text-foreground-600">按实时讨论热度排序，带上升/回落趋势标识。</p>
              </div>
            </div>

            <div className="mt-6 rounded-2xl bg-background-50 border border-background-200 divide-y divide-background-200/70">
              {hotTopics.map((t) => (
                <article
                  key={t.id}
                  className="flex items-center gap-4 px-4 md:px-5 py-3.5 transition-colors hover:bg-background-100/60"
                >
                  <span
                    className={
                      "w-9 h-9 shrink-0 flex items-center justify-center rounded-md font-heading text-lg font-black " +
                      (t.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500")
                    }
                  >
                    {t.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-sm md:text-base font-semibold text-foreground-900">{t.title}</h3>
                    <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-400">
                      <span>{t.category}</span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-fire-fill text-primary-500"></i>
                        {t.heat.toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <Trend trend={t.trend} />
                  <a
                    href="#timeline"
                    className="hidden sm:inline-flex items-center justify-center w-8 h-8 rounded-full border border-background-300 text-foreground-500 hover:border-primary-300 hover:text-primary-600 transition-colors"
                    aria-label="查看该话题进展"
                  >
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </article>
              ))}
            </div>
          </div>

          <aside className="space-y-5">
            <div className="rounded-2xl bg-primary-500 text-background-50 p-6">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs">
                <i className="ri-refresh-line"></i>
                追更小贴士
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold leading-snug">如何在几分钟内对齐一条长线瓜</h3>
              <ol className="mt-4 space-y-3 text-sm text-background-100/90 list-decimal list-inside">
                <li>先从话题榜点开正在跟进的事件</li>
                <li>看顶部「进展摘要」与进度条</li>
                <li>再沿时间线逐条读关键节点</li>
              </ol>
            </div>
            <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-shield-check-line text-primary-600"></i>
                理性吃瓜三原则
              </h3>
              <ul className="mt-3 space-y-2.5 text-xs leading-relaxed text-foreground-600">
                <li>· 未证实消息只看不传</li>
                <li>· 多方报道优先于单方口径</li>
                <li>· 等官方回应再下结论</li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}